export const PARENT_TYPE_CONSTANTS = {
    teacher: 'TEACHER',
    student: 'STUDENT',
    viewSubmission: 'VIEW_SUBMISSION',
    template: 'TEMPLATE',
};
